import { destroySession } from '@/app/actions/auth/cookies.action';
import { AxiosError, AxiosResponse } from 'axios';
// import { toast } from 'react-toastify';
// import { ErrorResponse } from '../methods.types';

export const responseInterceptor = (response: AxiosResponse) => {
   //  if (
   //     response.config.method !== 'get' &&
   //     !['user/available-email'].some(item => response.config.url?.includes(item))
   //  ) {
   //     toast.success(response.data.message);
   //  }
   return response;
};

export const responseErrorInterceptor = async (error: AxiosError) => {
   if (!error.response) {
      // toast.error('Network error: Please check your internet connection.');
      return Promise.reject(error);
   }
   if (error.response.status === 401) {
      await destroySession();
      window.location.href = '/auth/login';
   }
   //  const errorData = error.response.data as ErrorResponse;

   //  if (!['discount/free-card-settings'].some(item => error.config?.url?.includes(item))) toast.error(errorData.message);

   return Promise.reject(error);
};
